import { render, staticRenderFns } from "./TipoAlteracaoList.vue?vue&type=template&id=fb3cbe98"
import script from "./TipoAlteracaoList.vue?vue&type=script&lang=js"
export * from "./TipoAlteracaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports